import React, { useState, useEffect } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import { Link } from 'react-router-dom';
import confetti from "canvas-confetti"; // 🎉 Import confetti
import Captcha from "./Captcha.js";  //captchaa aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa

const Loader = () => (
    <div className="loader-wrap">
        <div className="preloader">
            <div className="preloader-close">close</div>
            <div id="handle-preloader" className="handle-preloader">
                <div className="animation-preloader">
                    <div className="txt-loading">
                        <img src="assets/images/animation_logo.gif" alt="Loading animation" />
                    </div>
                </div>
            </div>
        </div>
    </div>
);
const PageTitle = ({ title, breadcrumb }) => (
    <section className="page-title">
        <div
            className="bg-layer"
            style={{ backgroundImage: "url(assets/images/background/page-title.jpg)" }}
        ></div>
        <div className="line-grid-wrap">
            <span className="line-grid-1"></span>
            <span className="line-grid-2"></span>
            <span className="line-grid-3"></span>
            <span className="line-grid-4"></span>
            <span className="line-grid-5"></span>
        </div>
        <div className="auto-container">
            <div className="content-box">
                <h1 style={{ textAlign: "left" }}>{title}</h1>
                <ul className="bread-crumb clearfix">
                    <li><Link to="/">Home</Link>

                    </li>
                    <li>Contact Us

                    </li>

                </ul>
            </div>
        </div>
    </section>
);

const ContactForm = () => {
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });
    const [isVerified, setIsVerified] = useState(false);  //captchaa aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateField = (name, value) => {
        let error = "";

        if (name === "username") {
            if (!value) error = "User Name is required.";
            else if (/[^a-zA-Z\s]/.test(value)) error = "Enter a valid name (letters only).";
        }

        if (name === "email") {
            if (!value) error = "Email is required.";
            else if (!/\S+@\S+\.\S+/.test(value)) error = "Enter a valid email.";
        }

        if (name === "phone") {
            if (!value) error = "Phone Number is required.";
            else if (!/^\d+$/.test(value)) error = "Phone number should contain digits only.";
            else if (value.length > 10) error = "Phone number should not exceed 10 digits.";
        }

        if (name === "subject") {
            if (!value) error = "Subject is required.";
        }

        if (name === "message") {
            if (!value) error = "Message is required.";
        }

        return error;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        const error = validateField(name, value);

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors({
            ...errors,
            [name]: error,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!isVerified) {
            return; // Prevent submission if CAPTCHA is not verified
        }

        const formErrors = {};
        for (const field in formData) {
            formErrors[field] = validateField(field, formData[field]);
        }
        setErrors(formErrors);

        if (Object.values(formErrors).every((err) => !err)) {
            setIsSubmitted(true);
            triggerConfetti();
            setIsVerified(false); // Reset CAPTCHA verification after submission
        }
    };


    const handleContactAgain = () => {
        setIsSubmitted(false);
        setFormData({
            username: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
        });
        setErrors({});
    };
    const triggerConfetti = () => {
        var duration = 2 * 1000; // 2 seconds
        var end = Date.now() + duration;

        (function frame() {
            confetti({
                particleCount: 7,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ["#FF5733", "#FFC300", "#DAF7A6", "#C70039", "#581845"]
            });

            confetti({
                particleCount: 7,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ["#FF5733", "#FFC300", "#DAF7A6", "#C70039", "#581845"]
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        })();
    };

    return (
        <div className="auto-container">
            <div className="sec-title mb_50">
                <span className="sub-title mb_14">Get in Touch</span>
                <h2>Start your journey with us!</h2>
                <p>
                    Feel free to reach out to us! We are here to support all your financial needs. Whether you
                    have questions about our services, would like to schedule a consultation, or need
                    assistance, our team is here to help.
                </p>
            </div>

            <div className="form-container">
                <div className={`form-inner ${isSubmitted ? "slide-out" : "slide-in"}`}>
                    {!isSubmitted && (
                        <form
                            onSubmit={handleSubmit}
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "20px",
                            }}
                        >
                            {[
                                { name: "username", placeholder: "Name" },
                                { name: "email", placeholder: "Email" },
                                { name: "phone", placeholder: "Phone Number" },
                                { name: "subject", placeholder: "Subject" },
                                { name: "message", placeholder: "Message" },
                            ].map((field) => (
                                <div
                                    key={field.name}
                                    style={{
                                        flex: field.name === "message" ? "1 1 100%" : "1 1 48%",
                                    }}
                                >
                                    {field.name !== "message" ? (
                                        <input
                                            type={field.name === "email" ? "email" : "text"}
                                            name={field.name}
                                            placeholder={field.placeholder}
                                            value={formData[field.name]}
                                            onChange={handleInputChange}
                                            style={{
                                                padding: "10px",
                                                border: errors[field.name]
                                                    ? "1px solid red"
                                                    : "1px solid #ccc",
                                                borderRadius: "4px",
                                                width: "100%",
                                            }}
                                        />
                                    ) : (
                                        <textarea
                                            name={field.name}
                                            placeholder="Type Your Message"
                                            value={formData[field.name]}
                                            onChange={handleInputChange}
                                            style={{
                                                padding: "10px",
                                                border: errors[field.name]
                                                    ? "1px solid red"
                                                    : "1px solid #ccc",
                                                borderRadius: "4px",
                                                width: "100%",
                                                minHeight: "100px",
                                            }}
                                        ></textarea>
                                    )}
                                    {errors[field.name] && (
                                        <span style={{ color: "red" }}>{errors[field.name]}</span>
                                    )}
                                </div>
                            ))}
                            {/*captchaa aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa*/}
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <Captcha onVerified={setIsVerified} />
                                <button
                                    type="submit"
                                    className={`w-full p-2 rounded-md transition ${isVerified
                                            ? 'bg-blue-500 text-white hover:bg-blue-600'
                                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        }`}
                                    disabled={!isVerified}
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    )}
                </div>

                {isSubmitted && (
                    <div className="Contact-thank-you-messagee slide-in">
                        <h1>Thank you for reaching out!</h1>
                        <p>We have received your message and will get back to you soon.</p>
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <button
                                onClick={handleContactAgain}
                                style={{
                                    backgroundColor: "#d8a044",     
                                    color: "white",
                                    padding: "10px 20px",
                                    border: "none",
                                    cursor: "pointer",
                                    textTransform: "uppercase",
                                    borderRadius: "4px",
                                    marginTop:"70px",
                                }}
                            >
                                Contact Again
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};



const MapSection = () => (
    <section className="map-section">
        <div className="map-inner">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.799868245698!2d-80.2677719250315!3d26.007372498410973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9a8b00435f4c5%3A0xfc93002f0c8aa4a6!2s9050%20Pines%20Blvd%20450%203%2C%20Pembroke%20Pines%2C%20FL%2033025%2C%20USA!5e0!3m2!1sen!2sin!4v1727686369948!5m2!1sen!2sin"
                width="600"
                height="535"
                frameBorder="0"
                style={{ border: "0", width: "100%" }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
            ></iframe>
        </div>
    </section>
);

const ContactOne = () => {
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    return (
        <div className="boxed_wrapper ltr">
            {isLoading && <Loader />}
            <Header />
            <PageTitle title="Contact Us" breadcrumb={["Home", "Contact Us"]} />
            <section className="contact-page-section pt_110 pb_120" style={{ textAlign: "left" }}>
                <ContactForm />
            </section>
            <MapSection />
            <Footer />
            <div className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>
                <div>
                    <div className="scroll-top-inner">
                        <div className="scroll-bar">
                            <div className="bar-inner"></div>
                        </div>
                        <div className="scroll-bar-text">Go To Top</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactOne;



